import React from 'react';
import PropTypes from 'prop-types';
import ROUTES from 'components/Routes/routes';
import enhancer from './enhancer';
import LockedScreenDialog from './LockedScreenDialog';

const IdleTimer = ({ locked, location }) => (
  <LockedScreenDialog
    open={
      locked === true &&
      location !== ROUTES.LOGIN_CALLBACK &&
      location !== ROUTES.LOGIN &&
      location !== ROUTES.PARTNER
    } // don't show locked screen on popup or login
  />
);

IdleTimer.propTypes = {
  locked: PropTypes.bool,
  location: PropTypes.string.isRequired,
};

export default enhancer(IdleTimer);
